import Swiper from 'swiper';
import { Pagination, EffectFade } from 'swiper/modules';

const Page = {
  dropdowns: function () {

    // handle dropdowns
    const anchors = document.querySelectorAll('[data-faq] .anchor');
    if (anchors.length > 0) anchors.forEach(anchor => {
      const dropdown = anchor.nextElementSibling;

      anchor.addEventListener('click', () => {
        if (anchor.classList.contains('-active')) {
          anchor.classList.remove('-active');
          dropdown.style.height = 0;
        } else {
          anchor.classList.add('-active');
          dropdown.style.height = `${dropdown.scrollHeight}px`;
        }
      });
    });

  },
  atendimento: function () {

    // handle phone input
    const input_phone = document.querySelector('[data-input-phone]');
    if (input_phone) input_phone.addEventListener('input', function (e) {
      var x = e.target.value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,5})(\d{0,4})/);
      e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    });

  },
  loja: function () {
    const swiperEl = document.querySelector('[data-loja]');
    if (swiperEl) {
      const newSwiper = new Swiper(swiperEl, {
        modules: [Pagination, EffectFade],
        slidesPerView: 1,
        spaceBetween: 0,
        watchOverflow: true,
        speed: 1000,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        pagination: {
          clickable: true,
          bulletClass: 'bullet',
          bulletActiveClass: '-active',
          el: swiperEl.querySelector('.pagination'),
          renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
          },
        },
      });
      window.addEventListener('load', () => { newSwiper.update() });
    }
  },
  init: function () {
    if (window.location.href.includes('atendimento')) this.atendimento();
    if (window.location.href.includes('loja')) this.loja();
    this.dropdowns();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Page.init();
});
